<template>
  <div class="license-code-container">
    <div class="license-heading">
      Enter activation code to unlock your account
    </div>
    <div class="activation-widget-container">
      <activation :activators="activators" />
      <button
        :disabled="disabled"
        @click="activate"
      >
        Activate account
      </button>
    </div>
    <div
      v-if="errorMessage"
      class="errors"
    >
      <icon
        :name="'warning'"
        variant="dc3416"
      />
      {{ errorMessage }}
      <v-popover
        :auto-hide="false"
        :popover-class="'error-popover'"
        :offset="10"
        :trigger="'click'"
        :placement="'bottom'"
        :container="'#root .router-view'"
      >
        <button>More info</button>
        <template v-slot:popover>
          <div>1. Double check your code</div>
          <div>
            2. <router-link :to="{ name: 'support' }">
              Contact Support
            </router-link>
          </div>
        </template>
      </v-popover>
    </div>
  </div>
</template>
<script>
import Activation from '@components/activation/show';
import Icon from '@components/singletons/icon';

import ActivationMixin from '@/mixins/activation';

const ACTIVATION_EVENT = 'activation-code-change';

export default {
  components: { Activation, Icon },
  mixins: [ActivationMixin],
  data() {
    return {
      activationCodes: {},
      disabled: false,
      errorMessage: null,
    };
  },
  computed: {
    activators() {
      return this.$store.getters['activation/activators'].filter(a => a.activatorType !== 'Ase');
    },
  },
  created() {
    this.$eventBus.$on(ACTIVATION_EVENT, this.updateActivationCodes);
  },
  beforeDestroy() {
    this.$eventBus.$off(ACTIVATION_EVENT);
  },
  methods: {
    activate() {
      if (this.disabled) return;
      this.showErrors = null;

      const params = {
        activationCodes: this.activationCodes,
      };

      this.disabled = true;

      this.$store.dispatch('activation/activateUser', params).then(results => {
        this.activationCodeNotifications(results);
        const error = results.find(result => !result.status);
        if (error) {
          this.errorMessage = (error.errors || [])[0] || 'Invalid Activation Code';
        }
      }).finally(() => {
        this.disabled = false;
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.license-code-container {
  .license-heading {
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    margin-bottom: rem-calc(8);
  }

  .activation-widget-container {
    align-content: center;
    align-items: center;
    display: flex;
    flex-wrap: wrap;

    .activation-reset {
      > * {
        margin: rem-calc(8);
      }
    }

    /deep/ input {
      padding: rem-calc(4) rem-calc(8);

      &:last-child {
        margin-right: rem-calc(12);
      }
    }

    button {
      padding: rem-calc(6) rem-calc(20);
      background: #7bd56e;
      border-radius: 4px;
      border: solid 1px rgba(0, 0, 0, 0.1);
      color: white;
      font-size: rem-calc(14);
      font-weight: $semi-bold;
      // bottom margin needed to vertically center
      margin-bottom: rem-calc(4);

      &:disabled {
        cursor: not-allowed;
        opacity: 0.8;
      }
    }

    /deep/ label.title {
      display: none;
    }
  }

  .errors {
    align-items: center;
    color: #dc3416;
    display: flex;
    font-size: rem-calc(12);
    font-weight: $semi-bold;

    button {
      background: transparent;
      color: #dc3416;
      font-weight: $semi-bold;
      margin-left: rem-calc(6);
      // needed so if error text is too long it doesn't get squished
      min-width: rem-calc(60);
      padding: 0;
      text-decoration: underline;
    }

    img {
      // needed so if error text is too long it doesn't get squished
      flex-shrink: 0;
      height: rem-calc(16);
      margin-right: rem-calc(8);
    }
  }
}
</style>
<style lang='scss'>

.error-popover {
  line-height: 1.25;

  &.tooltip {
    border-radius: rem-calc(8);
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.4);
    z-index: 10000;

    &[x-placement^="bottom"] {
      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
      }
    }

    &.popover {
      $color: white;

      .popover-inner {
        background: $color;
        border-bottom: 8px solid #ed1c24;
        color: #354052;
        padding: rem-calc(16) rem-calc(24);
        border-radius: rem-calc(8);
        box-shadow: 0 5px 30px rgba(black, .1);

        a {
          color: #354052 !important;
        }
      }

      .popover-arrow {
        border-color: $color;
      }
    }
  }
}
</style>
